import { Languages } from "src/api/types";

export const languages: Languages[] = ["en", "es", "pt"] as const;
